import { createContext, useContext, useEffect, useMemo, useState } from "react";

const StealthCtx = createContext(null);

export function StealthProvider({ children }) {
  const [enabled, setEnabled] = useState(() => {
    try { return JSON.parse(localStorage.getItem("stealthMode") || "false"); }
    catch { return false; }
  });

  useEffect(() => {
    localStorage.setItem("stealthMode", JSON.stringify(enabled));
    document.body.classList.toggle("stealth-mode", enabled);
  }, [enabled]);

  const value = useMemo(() => ({
    enabled,
    enable: () => setEnabled(true),
    disable: () => setEnabled(false),
    toggle: () => setEnabled(v => !v),
  }), [enabled]);

  return <StealthCtx.Provider value={value}>{children}</StealthCtx.Provider>;
}

export function useStealthMode() {
  const ctx = useContext(StealthCtx);
  if (!ctx) throw new Error("useStealthMode must be used within <StealthProvider>");
  return ctx;
}